const EXPLORER_URL = process.env.API_URL + '/explorer/';

const VARIABLES_URL = EXPLORER_URL + 'variables';
const TIMELINE_DATA = EXPLORER_URL + 'timeline-data';
const CORRELATION_DATA = EXPLORER_URL + 'correlation-data';
const PAGINATED_VARIABLES = EXPLORER_URL + 'paginated-variables';
const VARIABLES_MINIMAL = EXPLORER_URL + 'minimal-variables';
const VARIABLES_MINIMAL_TAGGED = EXPLORER_URL + 'tagged-minimal-variables';
const HAS_TAGGED_VARIABLES = EXPLORER_URL + 'has-tagged-variables';
const MULTIPLE_CORRELATION_PAIRS = EXPLORER_URL + 'multiple-correlation-pairs';

const getVariables = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(VARIABLES_URL)
      .then(response => {
        resolve(parseResponse(response.body));
      }, error => {
        reject(error);
      });
  });
};

const parseResponse = vars => {
  return vars.map(variableResponse => {
    return {
      label: variableResponse.label,
      value: variableResponse
    };
  }).sort(labelCompare);
};

const labelCompare = (variable, other) => {
  if (variable.label < other.label) { return -1; }
  if (variable.label > other.label) { return 1; }
  return 0;
};

const getTimelineData = (context, variableIds, startDate, endDate) => {
  return new Promise((resolve, reject) => {
    context.$http.get(TIMELINE_DATA, {params: {variableIds, startDate, endDate}})
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const getCorrelationData = (context, variableIds, startDate, endDate) => {
  return new Promise((resolve, reject) => {
    context.$http.get(CORRELATION_DATA, {params: {variableIds, startDate, endDate}})
      .then(response => {
        resolve(response.body);
      }, error => {
        reject(error);
      });
  });
};

const getPaginatedVariables = (context, page, filter, orderField, order, tags) => {
  return context.$http.get(PAGINATED_VARIABLES, {params: {page, filter, orderField, order, tags}});
};

const getMinimalVariables = (context) => {
  return context.$http.get(VARIABLES_MINIMAL);
};

const getTaggedMinimalVariables = (context, tags, tagIntersection, filter) => {
  return context.$http.get(VARIABLES_MINIMAL_TAGGED, {params: {tags, tagIntersection, filter}});
};

const hasTaggedVariables = (context, tags, tagIntersection) => {
  return context.$http.get(HAS_TAGGED_VARIABLES, {params: {tags, tagIntersection}});
};

const getMultipleCorrelationVariablePairs = (context, tagsX, tagsY) => {
  return context.$http.get(MULTIPLE_CORRELATION_PAIRS, {params: {tagsX, tagsY}});
};

export default {
  getVariables,
  getTimelineData,
  getCorrelationData,
  getPaginatedVariables,
  getMinimalVariables,
  getTaggedMinimalVariables,
  hasTaggedVariables,
  getMultipleCorrelationVariablePairs
};



// WEBPACK FOOTER //
// ./src/api/variable/index.js